"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getXGenerationPromptLines = exports.buildXVoiceAdaptation = exports.getXRewriteGuidelines = exports.X_PLATFORM_OPTIMIZATION_LINE = exports.X_COPY_STANDARD = exports.X_COPY_MAX_CHARS = void 0;
const platform_enum_1 = require("./types/platform.enum");
/** Hard character limit for X posts (same as Platforms.x.constraints.message.max). */
exports.X_COPY_MAX_CHARS = platform_enum_1.Platforms[platform_enum_1.PlatformEnum.X].constraints.message.max;
/**
 * X copy standard (PRD Epic 3 / X-3.1).
 * Used to generate and rewrite X-native posts in the client's voice —
 * never by shortening another network's caption.
 */
exports.X_COPY_STANDARD = {
    lengthTarget: "Aim for 100–200 characters; hard max 280.",
    tone: "Punchy, conversational, and specific — sound like a sharp observation, not a press release or LinkedIn essay.",
    formatting: "One short idea. Prefer 1–2 short lines. No long paragraphs, no bullet lists, no corporate soft-openers.",
    hashtags: "0–2 highly relevant hashtags max, at the end. Skip hashtag stuffing.",
    linkPlacement: "If a link is included, put it at the end after the CTA. Prefer no link when the point stands alone.",
    neverCarryFromLinkedIn: [
        "Do not reuse, shorten, or paraphrase LinkedIn, Facebook, Instagram, or Threads captions for X",
        "Do not open with 'Excited to announce', 'I'm thrilled', or multi-paragraph insight essays",
        "Do not pad with filler or soft CTAs that read as cross-posted filler",
    ],
};
/** One-line summary for platform-optimization lists in multi-network generation. */
exports.X_PLATFORM_OPTIMIZATION_LINE = `X: distinct short post in the brand voice, roughly 100–200 characters (hard max ${exports.X_COPY_MAX_CHARS}); punchy and specific; 0–2 hashtags; never reuse or shorten another network's caption`;
/** Guidelines for rewrite / regenerate when platform is X. */
const getXRewriteGuidelines = () => [
    exports.X_COPY_STANDARD.lengthTarget,
    exports.X_COPY_STANDARD.tone,
    exports.X_COPY_STANDARD.formatting,
    exports.X_COPY_STANDARD.hashtags,
    exports.X_COPY_STANDARD.linkPlacement,
    ...exports.X_COPY_STANDARD.neverCarryFromLinkedIn,
];
exports.getXRewriteGuidelines = getXRewriteGuidelines;
/**
 * How to adapt the company's existing voice/tone into an X variant (PRD X-3.2).
 * Keeps one brand voice while applying X length and tone norms.
 */
const buildXVoiceAdaptation = (marketingVoice, toneOfVoice) => {
    const voice = marketingVoice.trim() || "the company's established marketing voice";
    const tone = toneOfVoice.trim() || "the company's established tone";
    return [
        `Adapt this brand voice for X without inventing a new brand: ${voice}`,
        `Keep the tone recognizable but compressed: ${tone}`,
        "On X, favor sharper wording and fewer words — the same personality, not a different persona.",
    ].join(" ");
};
exports.buildXVoiceAdaptation = buildXVoiceAdaptation;
/** Full prompt block when generating X posts as their own outputs. */
const getXGenerationPromptLines = (marketingVoice, toneOfVoice) => [
    (0, exports.buildXVoiceAdaptation)(marketingVoice, toneOfVoice),
    exports.X_COPY_STANDARD.lengthTarget,
    exports.X_COPY_STANDARD.tone,
    exports.X_COPY_STANDARD.formatting,
    exports.X_COPY_STANDARD.hashtags,
    exports.X_COPY_STANDARD.linkPlacement,
    ...exports.X_COPY_STANDARD.neverCarryFromLinkedIn,
    "Each X post must be written as its own output for platform x — never derived from another platform's copy in the same batch.",
];
exports.getXGenerationPromptLines = getXGenerationPromptLines;
